export default __webpack_public_path__ + "static/media/arrow_alt_right.bd801623.svg";